export const RELIABLE_VIDEO_PUBLISHER_OPTIONS = {
  resolution: '640x480',
  frameRate: 15,
  audioFallbackEnabled: true,
};

const isSlowConnection = () => {
  if (typeof navigator === 'undefined') return false;
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  return Boolean(
    connection?.saveData ||
    connection?.effectiveType === 'slow-2g' ||
    connection?.effectiveType === '2g' ||
    connection?.effectiveType === '3g'
  );
};

export const applyPublisherNetworkProfile = (publisher) => {
  if (!publisher) return;
  const slowConnection = isSlowConnection();

  try {
    if (typeof publisher.setMaxVideoBitrate === 'function') {
      const result = publisher.setMaxVideoBitrate(slowConnection ? 250000 : 500000);
      result?.catch?.((error) => {
        console.warn('[video-call] Unable to apply video network profile', error);
      });
      return;
    }
    if (typeof publisher.setVideoBitratePreset === 'function') {
      const result = publisher.setVideoBitratePreset(
        slowConnection ? 'extra_bw_saver' : 'bw_saver'
      );
      result?.catch?.((error) => {
        console.warn('[video-call] Unable to apply video network profile', error);
      });
    }
  } catch (error) {
    console.warn('[video-call] Unable to apply video network profile', error);
  }
};
